import React from 'react';

/**
 * Skeleton loader component for the news feed section
 * Provides visual feedback while news stories are loading
 */
const NewsFeedSkeleton = () => {
  return (
    <div className="news-feed news-feed-section-container news-feed-skeleton">
      {/* Title Skeleton */}
      <div className="skeleton-nf-title" />

      {/* Category Buttons Row Skeleton */}
      <div className="news-feed-buttons">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
          <div key={index} className="skeleton-nf-button" />
        ))}
      </div>

      {/* Two-column Layout Skeleton */}
      <div className="news-feed-wrapper">
        <div className="news-feed-layout">
          {/* Left Column - Feed List Skeleton */}
          <div className="feed-list-column">
            <div className="feed-list">
              {[1, 2, 3, 4, 5].map((index) => (
                <div key={index} className="feed-item skeleton-feed-item">
                  <div className="skeleton-nf-logo" />
                  <div className="skeleton-nf-content">
                    <div className="skeleton-nf-feed-title" />
                    <div className="skeleton-nf-feed-description" />
                    <div className="skeleton-nf-feed-description-short" />
                    <div className="skeleton-nf-feed-meta" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Feed Content Viewer Skeleton */}
          <div className="feed-content-column">
            <div className="feed-content-header">
              <div className="skeleton-nf-content-title" />
            </div>
            <div className="feed-content-body">
              <div className="feed-content-meta-top">
                <div className="skeleton-nf-article-image" />
              </div>
              <div className="skeleton-nf-text-block">
                <div className="skeleton-nf-text-line skeleton-nf-text-full" />
                <div className="skeleton-nf-text-line skeleton-nf-text-full" />
                <div className="skeleton-nf-text-line skeleton-nf-text-full" />
                <div className="skeleton-nf-text-line skeleton-nf-text-medium" />
                <div className="skeleton-nf-text-line skeleton-nf-text-full" />
                <div className="skeleton-nf-text-line skeleton-nf-text-full" />
                <div className="skeleton-nf-text-line skeleton-nf-text-short" />
              </div>
              <div className="skeleton-nf-read-more" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsFeedSkeleton;
